// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file common/v1/session.proto (package common.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { AuthOptions_CofOptions, CaptureOptions, CookiePolicy, FraudCheckOptions, PaymentMethodOptions, SoftMerchantDescriptor, SubMerchantSupplementalData } from "./common_pb";
import { Shopper } from "./shopper_pb";
import { PaymentCardScaRequest } from "./three_domain_secure_pb";

/**
 * Session's intent type.
 *
 * @generated from enum common.v1.IntentType
 */
export const IntentType = proto3.makeEnum(
  "common.v1.IntentType",
  [
    {no: 0, name: "INTENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "INTENT_TYPE_CHECKOUT", localName: "CHECKOUT"},
    {no: 2, name: "INTENT_TYPE_NONCE_GENERATION", localName: "NONCE_GENERATION"},
    {no: 3, name: "INTENT_TYPE_VERIFICATION", localName: "VERIFICATION"},
    {no: 4, name: "INTENT_TYPE_AUTHENTICATION", localName: "AUTHENTICATION"},
    {no: 5, name: "INTENT_TYPE_AUTHORIZATION", localName: "AUTHORIZATION"},
    {no: 6, name: "INTENT_TYPE_CHECKOUT_PBL", localName: "CHECKOUT_PBL"},
    {no: 7, name: "INTENT_TYPE_PROFILE_MANAGEMENT", localName: "PROFILE_MANAGEMENT"},
    {no: 8, name: "INTENT_TYPE_TOKENIZE_ONLY", localName: "TOKENIZE_ONLY"},
  ],
);

/**
 * @generated from enum common.v1.TransactionRequestTypeCode
 */
export const TransactionRequestTypeCode = proto3.makeEnum(
  "common.v1.TransactionRequestTypeCode",
  [
    {no: 0, name: "TRANSACTION_REQUEST_TYPE_CODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TRANSACTION_REQUEST_TYPE_CODE_CHECKOUT", localName: "CHECKOUT"},
    {no: 2, name: "TRANSACTION_REQUEST_TYPE_CODE_NONCE_GENERATION", localName: "NONCE_GENERATION"},
    {no: 3, name: "TRANSACTION_REQUEST_TYPE_CODE_VERIFICATION", localName: "VERIFICATION"},
    {no: 4, name: "TRANSACTION_REQUEST_TYPE_CODE_AUTHORIZATION", localName: "AUTHORIZATION"},
    {no: 5, name: "TRANSACTION_REQUEST_TYPE_CODE_CHECKOUT_PBL", localName: "CHECKOUT_PBL"},
    {no: 6, name: "TRANSACTION_REQUEST_TYPE_CODE_PROFILE_MANAGEMENT", localName: "PROFILE_MANAGEMENT"},
    {no: 7, name: "TRANSACTION_REQUEST_TYPE_CODE_TOKENIZE_ONLY", localName: "TOKENIZE_ONLY"},
  ],
);

/**
 * @generated from message common.v1.SessionMetadata
 */
export const SessionMetadata = proto3.makeMessageType(
  "common.v1.SessionMetadata",
  () => [
    { no: 1, name: "transaction_request_type_code", kind: "enum", T: proto3.getEnumType(TransactionRequestTypeCode) },
    { no: 2, name: "merchant_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "soft_merchant", kind: "message", T: SoftMerchantDescriptor },
    { no: 5, name: "card_on_file", kind: "message", T: AuthOptions_CofOptions },
    { no: 6, name: "consumer", kind: "message", T: Shopper },
    { no: 7, name: "is_estimated_amount", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "sub_merchant_supplemental_data", kind: "message", T: SubMerchantSupplementalData },
    { no: 9, name: "fraud_check_options", kind: "message", T: FraudCheckOptions },
    { no: 11, name: "capture", kind: "message", T: CaptureOptions },
    { no: 12, name: "payment_card_authentication_request", kind: "message", T: PaymentCardScaRequest },
    { no: 13, name: "purchase_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "payment_method_options", kind: "message", T: PaymentMethodOptions },
    { no: 15, name: "cookie_policy", kind: "enum", T: proto3.getEnumType(CookiePolicy) },
  ],
);

